// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--kdzQb","logo":"styles-module--logo--3SEpy","logoImage":"styles-module--logoImage--t57aq","logoType":"styles-module--logoType--3k0zu"};